const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the event prework url component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('eventPrework', [function () {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      urls: '=',
      instructions: '='
    },
    template: require('../../../templates/directives/cms/event-prework.html'),
    link: function (scope) {
      scope.editUrl = {
        newUrl: '',
        addUrl: function(keyPress) {
          if (keyPress !== 'click' && keyPress.which !== 13 || !this.newUrl) {
            return;
          }
          
          if (!scope.urls) {
            scope.urls = [];
          }
          
          scope.urls.push(this.newUrl);
          this.newUrl = '';
        },
        removeUrl: function(index) {
          scope.urls.splice(index, 1);
        }
      };
    }
  };
}]);
